import type { Level } from "./types";

/**
 * Stars for a day given the best completed roster's total gold:
 *   3 — matched the proven-best roster (level.opt is the exact maximum,
 *       so "≥" can only bind at equality — levels.test.ts proves it)
 *   2 — at least the greedy best-pair-first baseline (the obvious play)
 *   1 — completed a roster at all
 *   0 — no completed roster yet (total 0 = never completed)
 * All payoffs are integers, so exact comparisons are safe.
 */
export function starsFor(level: Level, bestTotal: number): number {
  if (bestTotal <= 0) return 0;
  if (bestTotal >= level.opt) return 3;
  if (bestTotal >= level.greedy) return 2;
  return 1;
}
